import type { NlsLocale, NlsTypographyPolicy } from './nlsTypes'

export const NLS_MAJOR_LOCALES: NlsLocale[] = ['en', 'zh-Hans', 'es', 'hi', 'fr', 'ar', 'pt']

export const NLS_HELPER_APP_LOCALES: NlsLocale[] = [
  'en',
  'hi',
  'bn',
  'ta',
  'te',
  'mr',
  'gu',
  'ur',
  'kn',
  'or',
  'ml',
  'es',
  'pt',
  'fr',
  'ar',
  'ru',
  'ja',
  'de',
  'ko',
  'tr',
  'vi',
  'it',
  'fa',
  'pl',
  'uk',
  'nl',
  'th',
  'id',
  'ms',
  'fil',
]

export const NLS_LOCALE_LABELS: Record<NlsLocale, { label: string; nativeLabel: string }> = {
  en: { label: 'English', nativeLabel: 'English' },
  'zh-Hans': { label: 'Mandarin Chinese', nativeLabel: '简体中文' },
  es: { label: 'Spanish', nativeLabel: 'Español' },
  hi: { label: 'Hindi', nativeLabel: 'हिन्दी' },
  fr: { label: 'French', nativeLabel: 'Français' },
  ar: { label: 'Standard Arabic', nativeLabel: 'العربية' },
  pt: { label: 'Portuguese', nativeLabel: 'Português' },
  bn: { label: 'Bengali', nativeLabel: 'বাংলা' },
  ta: { label: 'Tamil', nativeLabel: 'தமிழ்' },
  te: { label: 'Telugu', nativeLabel: 'తెలుగు' },
  mr: { label: 'Marathi', nativeLabel: 'मराठी' },
  gu: { label: 'Gujarati', nativeLabel: 'ગુજરાતી' },
  ur: { label: 'Urdu', nativeLabel: 'اردو' },
  kn: { label: 'Kannada', nativeLabel: 'ಕನ್ನಡ' },
  or: { label: 'Odia', nativeLabel: 'ଓଡ଼ିଆ' },
  ml: { label: 'Malayalam', nativeLabel: 'മലയാളം' },
  ru: { label: 'Russian', nativeLabel: 'Русский' },
  ja: { label: 'Japanese', nativeLabel: '日本語' },
  de: { label: 'German', nativeLabel: 'Deutsch' },
  ko: { label: 'Korean', nativeLabel: '한국어' },
  tr: { label: 'Turkish', nativeLabel: 'Türkçe' },
  vi: { label: 'Vietnamese', nativeLabel: 'Tiếng Việt' },
  it: { label: 'Italian', nativeLabel: 'Italiano' },
  fa: { label: 'Persian', nativeLabel: 'فارسی' },
  pl: { label: 'Polish', nativeLabel: 'Polski' },
  uk: { label: 'Ukrainian', nativeLabel: 'Українська' },
  nl: { label: 'Dutch', nativeLabel: 'Nederlands' },
  th: { label: 'Thai', nativeLabel: 'ไทย' },
  id: { label: 'Indonesian', nativeLabel: 'Bahasa Indonesia' },
  ms: { label: 'Malay', nativeLabel: 'Bahasa Melayu' },
  fil: { label: 'Filipino', nativeLabel: 'Filipino' },
}

export const NLS_TYPOGRAPHY: Record<NlsLocale, NlsTypographyPolicy> = {
  en: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  'zh-Hans': { dir: 'ltr', fontScale: 0.98, compactFontScale: 0.94, lineHeight: 1.58, compactLineHeight: 1.28 },
  es: { dir: 'ltr', fontScale: 0.99, compactFontScale: 0.96, lineHeight: 1.52, compactLineHeight: 1.22 },
  hi: { dir: 'ltr', fontScale: 0.98, compactFontScale: 0.95, lineHeight: 1.68, compactLineHeight: 1.36 },
  fr: { dir: 'ltr', fontScale: 0.99, compactFontScale: 0.96, lineHeight: 1.52, compactLineHeight: 1.22 },
  ar: { dir: 'rtl', fontScale: 1, compactFontScale: 0.97, lineHeight: 1.68, compactLineHeight: 1.36 },
  pt: { dir: 'ltr', fontScale: 0.99, compactFontScale: 0.96, lineHeight: 1.52, compactLineHeight: 1.22 },
  bn: { dir: 'ltr', fontScale: 0.98, compactFontScale: 0.94, lineHeight: 1.68, compactLineHeight: 1.36 },
  ta: { dir: 'ltr', fontScale: 0.98, compactFontScale: 0.94, lineHeight: 1.72, compactLineHeight: 1.38 },
  te: { dir: 'ltr', fontScale: 0.98, compactFontScale: 0.94, lineHeight: 1.72, compactLineHeight: 1.38 },
  mr: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  gu: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  ur: { dir: 'rtl', fontScale: 1, compactFontScale: 0.97, lineHeight: 1.68, compactLineHeight: 1.36 },
  kn: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  or: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  ml: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  ru: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  ja: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  de: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  ko: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  tr: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  vi: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  it: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  fa: { dir: 'rtl', fontScale: 1, compactFontScale: 0.97, lineHeight: 1.68, compactLineHeight: 1.36 },
  pl: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  uk: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  nl: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  th: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  id: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  ms: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
  fil: { dir: 'ltr', fontScale: 1, compactFontScale: 1, lineHeight: 1.5, compactLineHeight: 1.2 },
}

export const normalizeNlsLocale = (locale: string | null | undefined): NlsLocale => {
  if (!locale) return 'en'
  const normalized = locale.trim()
  if (NLS_MAJOR_LOCALES.includes(normalized as NlsLocale)) return normalized as NlsLocale
  if (NLS_HELPER_APP_LOCALES.includes(normalized as NlsLocale)) return normalized as NlsLocale

  const lower = normalized.toLowerCase()
  if (
    lower === 'zh'
    || lower === 'zh-cn'
    || lower === 'zh-sg'
    || lower === 'zh-tw'
    || lower === 'zh-hk'
    || lower === 'zh-mo'
    || lower.startsWith('zh-hans')
    || lower.startsWith('zh-hant')
  ) return 'zh-Hans'
  if (lower.startsWith('es')) return 'es'
  if (lower.startsWith('hi')) return 'hi'
  if (lower.startsWith('fr')) return 'fr'
  if (lower.startsWith('ar')) return 'ar'
  if (lower.startsWith('pt')) return 'pt'
  if (lower.startsWith('bn')) return 'bn'
  if (lower.startsWith('ta')) return 'ta'
  if (lower.startsWith('te')) return 'te'
  if (lower.startsWith('mr')) return 'mr'
  if (lower.startsWith('gu')) return 'gu'
  if (lower.startsWith('ur')) return 'ur'
  if (lower.startsWith('kn')) return 'kn'
  if (lower === 'or' || lower.startsWith('or-')) return 'or'
  if (lower.startsWith('ml')) return 'ml'
  if (lower.startsWith('ru')) return 'ru'
  if (lower.startsWith('ja')) return 'ja'
  if (lower.startsWith('de')) return 'de'
  if (lower.startsWith('ko')) return 'ko'
  if (lower.startsWith('tr')) return 'tr'
  if (lower.startsWith('vi')) return 'vi'
  if (lower.startsWith('it')) return 'it'
  if (lower.startsWith('fa')) return 'fa'
  if (lower.startsWith('pl')) return 'pl'
  if (lower.startsWith('uk')) return 'uk'
  if (lower.startsWith('nl')) return 'nl'
  if (lower.startsWith('th')) return 'th'
  if (lower.startsWith('id')) return 'id'
  if (lower.startsWith('ms')) return 'ms'
  if (lower.startsWith('fil') || lower === 'tl' || lower.startsWith('tl-')) return 'fil'
  return 'en'
}

export const normalizeHelperAppLocale = (locale: string | null | undefined): NlsLocale => {
  const normalized = normalizeNlsLocale(locale)
  return NLS_HELPER_APP_LOCALES.includes(normalized) ? normalized : 'en'
}
